import React from "react";
import { ListItemProps } from "@mui/material";

import { useCurrentUser } from "../../hooks/useCurrentUser";

import { useLocation } from "react-router-dom";
import { COACH_EXERCISE_LIBRARY_PUBLISHED_ROUTE } from "../../routes/routes";
import { LibraryBig as LibraryIcon } from "lucide-react";
import { LibraryNavItemList } from "./LibraryNavItemList";
import { ExpandableNavItem } from "../item/ExpandableNavItem";
import { menuItems } from "../app/constants";

export interface LibraryNavItemProps extends ListItemProps {
  minimized?: boolean;
  setDrawerMinimized?: React.Dispatch<React.SetStateAction<boolean>>;
}

export function LibraryNavItem(props: LibraryNavItemProps) {
  const { className, minimized, setDrawerMinimized } = props;
  const user = useCurrentUser();
  const location = useLocation();
  const active = location.pathname.includes("/library");

  const totalCount = menuItems.library.length;

  return (
    <ExpandableNavItem
      className={className}
      icon={<LibraryIcon />}
      label="Library"
      active={active}
      coachRedirectPath={COACH_EXERCISE_LIBRARY_PUBLISHED_ROUTE}
      totalCount={totalCount}
      minimized={minimized}
      setDrawerMinimized={setDrawerMinimized}
      children={<LibraryNavItemList />}
    />
  );
}
